<app-toast></app-toast>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full max-w-ultrawide">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full max-w-ultrawide">
        <app-admin-navigation [isActiveNumber]="13"></app-admin-navigation>
    </div>

    <div class="flex w-full max-w-ultrawide mobile:flex-col desktop:justify-between items-center">
        <div class="flex flex-col gap-2">
            <!-- Header -->
            <div class="flex gap-2 w-full mt-4 max-w-ultrawide">
                <img src="assets/icons/admin/hash-blue.svg" class="w-[24px] h-[24px]"
                    alt="{{ 'shared.icon' | transloco }}">
                <h1 class="font-bold text-xl">
                    {{ 'admin.variables' | transloco }}</h1>
            </div>
            <p class="text-neutral-500 self-start mt-2"> {{ 'admin.variables_desc' | transloco }}</p>
        </div>
    </div>

    <div class="flex w-full mt-4">
        <p class="text-lg font-bold">{{ 'admin.raw_system_data' | transloco }}:</p>
    </div>
    <!-- Content -->
    <div class="w-full max-w-ultrawide mt-4 flex flex-col gap-2 bg-neutral-100 p-4 rounded-xl">

        <!-- Card -->
        <div class="flex flex-col gap-2 w-full rounded-xl border border-border shadow-md bg-[#FFFFFF] p-4"
            *ngFor="let variable of systemVariables">
            <!-- Body -->
            <div class="p-4 flex flex-col gap-2">
                <p class="font-bold text-xl">#{{ variable.public_name }}</p>

                <div class="flex">
                    <div class="inline-flex items-center rounded-xl p-2"
                        [ngClass]="getDataTypeBackgroundColor(variable.type)">
                        <p class="text-neutral-500 text-xs">{{ variable.type }}</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>